import { supabase } from './supabase'

// Photos live in private buckets. We store a reference "bucket/path"
// in the database and turn it into a short-lived signed link to display.
// Older rows hold full ".../object/public/bucket/path" URLs; those are
// understood too, so nothing needs to be re-uploaded.

const SIGNED_TTL_SECONDS = 60 * 60
const cache = new Map() // ref -> { url, expires }

export async function uploadPrivate(bucket, path, fileOrBlob, contentType) {
  const { error } = await supabase.storage.from(bucket).upload(path, fileOrBlob, contentType ? { contentType } : undefined)
  if (error) throw error
  return `${bucket}/${path}`
}

export function parseStorageRef(value) {
  if (!value || typeof value !== 'string') return null
  if (/^(blob:|data:)/.test(value)) return null
  if (/^https?:\/\//.test(value)) {
    const m = value.match(/\/storage\/v1\/object\/(?:public|sign|authenticated)\/([^/?]+)\/([^?]+)/)
    if (!m) return null
    return { bucket: m[1], path: decodeURIComponent(m[2]) }
  }
  const i = value.indexOf('/')
  if (i <= 0) return null
  return { bucket: value.slice(0, i), path: value.slice(i + 1) }
}

export async function resolveStorageUrl(value) {
  if (!value) return null
  const ref = parseStorageRef(value)
  if (!ref) return value // blob:, data: or an external link: use as is
  const key = `${ref.bucket}/${ref.path}`
  const hit = cache.get(key)
  if (hit && hit.expires > Date.now()) return hit.url
  const { data, error } = await supabase.storage.from(ref.bucket).createSignedUrl(ref.path, SIGNED_TTL_SECONDS)
  if (error || !data?.signedUrl) return null
  cache.set(key, { url: data.signedUrl, expires: Date.now() + (SIGNED_TTL_SECONDS - 120) * 1000 })
  return data.signedUrl
}
